import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { classNames } from "primereact/utils";

import { actionTooltipProps, Icon } from "@/ds";
import { UserAvatar } from "@/shared/components/user-avatar";

import styles from "./user-contact-card.module.scss";
import type { UserContactCardViewModel } from "./types-user-contact-card";

/** Cartão de contato (Figma info-user-card 9961:116556; no modal, Editar Usuário 5033:103820): foto, nome e as linhas de contato. */
export function UserContactCardView({
  rest,
  className,
  titulo,
  nome,
  email,
  telefone,
  detalhe,
  fotoSrc,
  avatarClassName,
  testIds,
  copy,
  copiarEmail,
}: UserContactCardViewModel) {
  return (
    <div data-testid={testIds?.root} {...rest} className={classNames(styles.card, className)}>
      {titulo ? <h3 className={styles.titulo}>{titulo}</h3> : null}

      <div className={styles.corpo}>
        <UserAvatar
          className={classNames(styles.avatar, avatarClassName)}
          nome={nome}
          fotoSrc={fotoSrc}
        />

        <div className={styles.userInfo}>
          <p className={styles.userName} data-testid={testIds?.name}>
            {nome}
          </p>

          <ul className={styles.contacts}>
            {email ? (
              <li className={`${styles.contact} ${styles.contactEmail}`}>
                <span className={styles.contactMain}>
                  <Icon name="envelope" size={14} className={styles.contactIcon} />
                  <span className={styles.contactText} data-testid={testIds?.email}>
                    {email}
                  </span>
                </span>
                <Button
                  id={copy.id}
                  type="button"
                  text
                  className={classNames("p-button-icon-inline", styles.copyButton)}
                  onClick={copiarEmail}
                  aria-label={copy.label}
                  data-testid={testIds?.copy}
                  icon={<Icon name="copy" size={14} />}
                />
                <Tooltip target={`#${copy.id}`} {...actionTooltipProps(copy.tooltip)} />
              </li>
            ) : null}

            {telefone ? (
              <li className={styles.contact}>
                <Icon name="phone" size={14} className={styles.contactIcon} />
                <span className={styles.contactText} data-testid={testIds?.phone}>
                  {telefone}
                </span>
              </li>
            ) : null}

            {detalhe ? (
              <li className={styles.contact}>
                <Icon name="users" size={14} className={styles.contactIcon} />
                <span className={styles.contactText} data-testid={testIds?.detail}>
                  {detalhe}
                </span>
              </li>
            ) : null}
          </ul>
        </div>
      </div>
    </div>
  );
}
